module.exports = __webpack_public_path__ + "img/BEARD 1.5f25ca1.svg";